// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgElectricityAndGas = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M23.085 14.588c-.02 3.467-2.61 6.261-5.784 6.24-2.462 0-5.393-1.875-6.463-4.43l.686-.342a6.857 6.857 0 0 0 3.363 3.35 3.404 3.404 0 0 1-.487-1.766c.001-.437.073-.872.213-1.286.2-.56.473-1.092.812-1.58.158-.258 1.22-1.855 1.595-2.466l.315-.49.305.494c.48.771 1.67 2.61 1.608 2.51.331.475.6.991.799 1.536.13.414.192.847.182 1.282a3.427 3.427 0 0 1-.446 1.666 5.513 5.513 0 0 0 2.561-4.718 6.858 6.858 0 0 0-.308-2.27 13.44 13.44 0 0 0-1.574-2.927c.127.202-1.989-2.997-3.147-4.8-.991 1.498-2.767 4.152-3.007 4.519l-.614-.477c.274-.404 2.462-3.675 3.326-4.985l.312-.477.295.48c1.028 1.622 3.565 5.483 3.428 5.274.912 1.405 1.382 2.262 1.666 3.12.263.821.386 1.681.364 2.543zm-7.907 3.045a1.82 1.82 0 0 0 0 .195 2.24 2.24 0 0 0 2.246 2.24c1.186-.042 2.105-1.15 2.057-2.442a3.128 3.128 0 0 0-.137-1.008 6.034 6.034 0 0 0-.72-1.344c.069.09-.75-1.152-1.303-2.026-.476.744-1.162 1.776-1.285 1.975a6.13 6.13 0 0 0-.72 1.388c-.103.333-.149.68-.138 1.029z"
    />
    <path
      fill="currentColor"
      d="M14.616 10.162a.432.432 0 0 1-.093.2l-7.2 9.445a.371.371 0 0 1-.29.147.344.344 0 0 1-.148-.038.419.419 0 0 1-.227-.407l.686-5.83H1.303a.377.377 0 0 1-.343-.232.44.44 0 0 1 .055-.44l7.2-9.445a.367.367 0 0 1 .343-.144.405.405 0 0 1 .322.46l-.686 5.828h6.062a.377.377 0 0 1 .343.237c.025.07.03.146.017.219zm-1.159.384H7.77a.367.367 0 0 1-.284-.14.446.446 0 0 1-.09-.323l.563-4.94-5.873 7.707h5.684a.364.364 0 0 1 .281.14.432.432 0 0 1 .09.323l-.56 4.91z"
    />
  </svg>
);
export default SvgElectricityAndGas;
